<!--div class=""-->
    <section class="heading">
        <h1>Video List</h1>
        <p>Welcome to our video list page. Here you can find a collection of videos.</p>
    </section>
    <section class="categories-listing row">
@for( category of categories; track category ){
        <div class="categorita">
            <a [routerLink]="['/content', category]">
                <div class="categorita-content">
                    <h3>{{ category }}</h3>
                </div>
            </a>
        </div>
}
    </section>
    <section class="videos row">
@for(video of videos; track video) {
        <div class="video column">
            <h2>{{ video.title }}</h2>
            <p>{{ video?.description }}</p>
            <video src="/assets/videos/{{ video.category }}/{{ video.name }}" controls poster="/assets/videos/{{ video.category }}/thumbnail.png" ></video>
        </div>
}
    </section>
<!--/div-->
